import React, { Component, Fragment } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import Top from '../Top/Top';
import InternalNavigation from '../Header/InternalNavigation';
import TemplateParser from '../Templates/TemplateParser';
import TemplateParserDeprecated from '../Templates/TemplateParserDeprecated';
import { translate, prefix } from '../../utils/locale';
import { urlify } from '../../utils/string';
import { offset, scrollTo } from '../../utils/dom';
import { deepClone, deepMerge } from '../../utils/object';
import s from './Page.scss';

class Page extends Component {
	constructor(props) {
		super(props);

		this.pageElement = React.createRef();
	}

	componentDidMount() {
		if (this.props.hashLocation || window.location.hash !== '') this.scrollToHash();
	}

	componentDidUpdate(prevProps) {
		if (this.props.hashLocation && this.props.hashLocation !== prevProps.hashLocation) this.scrollToHash();
	}

	scrollToHash() {
		let imagesLoaded = null;
		const hashLocation = this.props.hashLocation || window.location.hash;

		const allLoaded = () => {
			if (this.pageElement !== undefined) {
				const imgs = this.pageElement.current.querySelectorAll('img');
				imagesLoaded = [...imgs].length;

				[...imgs].forEach((img) => {
					if (img.complete) imagesLoaded -= 1;
				});
			}

			if (this.pageElement !== undefined && imagesLoaded === 0) {
				// Delay to understand page navigation
				setTimeout(() => {
					const position = offset(document.getElementById(hashLocation.replace('#', ''))).top - 80;
					scrollTo(500, position);
				}, 300);
			} else {
				setTimeout(allLoaded, 50);
			}
		};

		allLoaded();
	}

	render() {
		const { data, navigation, setup, currentPath, location } = this.props;
		if (!data.content) return null;
		const pageClasses = [s.page_inner];
		if (data.addMenu) pageClasses.push(s.page_inner__withMenu);

		const extraData = {};
		const inPageMenu = data?.content?.section ? data.content.section.filter((section) => section?.sectionTitle?.showInMenu && section?.sectionTitle?.text) : [];
		if (data.content?.articleList) {
			Object.keys(data.content.articleList).forEach((list) => {
				if (data[list]) extraData[list] = deepClone(data[list]);
			});
		}
		if (data?.content?.meta?.default?.tags?.restricted) extraData.restrictedCampaign = true;

		return (
			<>
				{ inPageMenu.length > 0 ? <InternalNavigation sections={inPageMenu} setup={setup} product={data?.content?.productLink?.products} customLink={data?.content?.custom} /> : null }
				<main role="main">
					{/* <Link to="/store-locator-test">Store locator test link</Link> */}
					<Top setup={setup} pageContent={deepMerge((data.content?.meta?.default || {}), (data.content.meta?.[setup.language] || {}))} paths={data.paths} locationType={location.type} />
					<div className={s.page} ref={this.pageElement}>
						{
							data.addMenu ? (
								<div className={s.page_menu}>
									{
										navigation.support.map((link) => (
											<Link className={[s.page_menu_link, (currentPath === translate(setup, link, 'uri') ? s.page_menu_link__active : null)].join(' ')} key={urlify(link.title)} to={prefix(setup, translate(setup, link, 'uri'))}>
												<span>{translate(setup, link, 'title').replace('&#038;', '&')}</span>
											</Link>
										))
									}
								</div>
							) : null
						}
						<div className={pageClasses.join(' ')}>
							<div>
								{ data?.content?.meta?.default?.tags?.acf && <TemplateParserDeprecated sections={data.content.section} setup={setup} {...extraData} /> }
								{ data?.content?.sections && <TemplateParser currentPath={currentPath} sections={data.content.sections} setup={setup} {...extraData} /> }
							</div>
						</div>
					</div>
				</main>
			</>
		);
	}
}

const mapState = ({ environment, location }, { data, currentPath }) => ({
	data,
	currentPath,
	hashLocation: environment.hashLocation,
	navigation: environment.navigation,
	setup: environment.setup,
	location,
});

export default hot(module)(connect(mapState)(Page));
